import axios from "axios";
import { Toast } from 'vant';
// axios.defaults.baseURL = 'https://api.xtbapp.cn/phalapi/' //国内正式
axios.defaults.baseURL = 'https://apidev.xtbapp.chat/phalapi/' //国内测试

// axios.defaults.baseURL = 'https://api.besideyou.cc/phalapi/' //越南正式
// axios.defaults.baseURL = 'https://apidev.useappapi.vip/phalapi/' //越南测试

// axios.defaults.baseURL = 'http://119.45.230.231/phalapi/'
axios.defaults.headers['Content-Type'] = 'application/json';
// axios.defaults.headers['Authorization'] = localStorage.getItem('token') || 'Bearer'
// Add a request interceptor
// axios.interceptors.request.use(function (config) {
// 	// Do something before request is sent
// 	// config.headers['Authorization'] = localStorage.getItem('token') || 'Bearer'
// 	return config;
// }, function (error) {
// 	// Do something with request error
// 	Promise.reject(error);
// });
axios.interceptors.request.use(config => {
    // 可以在这里添加请求前的处理逻辑
    return config;
}, error => {
    // 对请求错误做些什么
    console.error( error);
    return 
});


// 响应拦截器
axios.interceptors.response.use(response => {
    // 对响应数据做点什么
    let statusCode = response.data.data.code
	if (statusCode == '0') {
		return response.data
	} else {
		let status = response.data.ret
		if (status == 200) {
			return response.data
		} else {
			Toast(response.data.msg)
			return
		}
	}
}, error => {
    if (error.response) {
        // 请求已发出，服务器用状态码响应
        console.error('1 ', error.response);
    } else if (error.request) {
        // 请求已发出但没有收到响应
        // 可能是网络问题，请求被中断
		// Toast('Lỗi mạng!')
        console.error('2', error.request);
    } else {
        // 在设置发送请求的过程中发生错误
        console.error('3', error.message);
    }
    // 可以在这里处理错误响应
    return 
});

export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params
		}).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data)
		})
	});
}
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
// export default axios
